/*eslint-disable*/
import React from 'react';
import { useFormikContext, useField } from 'formik';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
export const DateData = ({ ...props }) => {
  const { setFieldValue } = useFormikContext()
  const [field] = useField(props);
  return (
    <>
      <DatePicker
        {...field}
        {...props}
        selected={(field.value && new Date(field.value)) || null}
        onChange={val => {
          setFieldValue(field.name, val);
          if (props?.setFlag) {
            setFieldValue(props.setFlag, 1)
          }
        }}
      />
      {/* {console.log("DateDATA=====>", field,props)} */}
    </>
  )
}
